import { styled } from 'linaria/react';

export const FilterList = styled.ul<{ className?: string }>`
	display: grid;
	padding: 0;
	margin: 0;
`;
